import {DataListModel} from '../interface';
import {ReferenceModel} from './reference.model';

export class ReferencesModel extends DataListModel {
  items: ReferenceModel[] = [];
}
